import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { useAuthStore } from '@/lib/store/auth'
import { Button } from '@/components/ui/button'
import { Reveal } from './reveal'

export function FinalCta() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const openLoginDialog = useAuthStore((s) => s.openLoginDialog)
  const handleCta = () => {
    if (isAuthenticated) navigate('/dashboard')
    else openLoginDialog()
  }

  return (
    <section className="mx-auto max-w-6xl px-6 py-24">
      <Reveal>
        <div className="glass-panel relative overflow-hidden rounded-3xl px-8 py-20 text-center">
          <div
            className="landing-ambient"
            style={{ top: '-30%', left: '20%', width: '300px', height: '300px' }}
            aria-hidden
          />
          <div
            className="landing-ambient"
            style={{ bottom: '-30%', right: '20%', width: '300px', height: '300px', animationDelay: '6s' }}
            aria-hidden
          />

          <div className="relative">
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
              {t('landing.finalCta.title')}
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base text-muted-foreground sm:text-lg">
              {t('landing.finalCta.body')}
            </p>
            <div className="mt-10 flex justify-center">
              <Button size="lg" onClick={handleCta} className="group">
                <span className="flex items-center gap-2">
                  {t('landing.finalCta.button')}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
